import { apiV2, errorHandler } from "./index";
import { API_ERROR, DELETE_ROLE, DELETE_ROLE_ERROR, DELETE_ROLE_SUCCESS, FETCH_ALL_ROLES, FETCH_ALL_ROLES_ERROR, FETCH_ALL_ROLES_SUCCESS, FETCH_ONE_ROLE, FETCH_ONE_ROLE_ERROR, FETCH_ONE_ROLE_SUCCESS, SAVE_ROLE, SAVE_ROLE_ERROR, SAVE_ROLE_SUCCESS } from "../constants/ActionTypes";
import Swal from "sweetalert2";

export function fetchAllRoles() {
  return function (dispatch) {
    dispatch({
      type: FETCH_ALL_ROLES
    });

    apiV2.get('/admin-roles')
      .then((response) => {
        dispatch({
          type: FETCH_ALL_ROLES_SUCCESS,
          payload: response.data.objects || response.data
        })
      })
      .catch((error) => {
        dispatch({
          type: FETCH_ALL_ROLES_ERROR,
          payload: []
        });
        errorHandler(dispatch, error.response, API_ERROR);
      })
  }
}

export function saveRole(data, onSuccess) {
  return function (dispatch) {
    dispatch({
      type: SAVE_ROLE
    });

    const request = data.role_id
      ? apiV2.put(`/admin-roles/${data.role_id}`, data)
      : apiV2.post('/admin-roles', data);

    request
      .then((response) => {
        dispatch({
          type: SAVE_ROLE_SUCCESS,
          payload: data
        });
        Swal.fire({
          icon: "success",
          title: "Role saved successfully!",
          timer: 2000
        }).then(() => {
          onSuccess?.();
        });
      })
      .catch((error) => {
        dispatch({
          type: SAVE_ROLE_ERROR,
          payload: []
        });
        errorHandler(dispatch, error.response, API_ERROR);
      })
  }
}

export function deleteRole(role_id) {
  return function (dispatch) {
    dispatch({
      type: DELETE_ROLE
    });

    apiV2.delete(`/admin-roles/${role_id}`)
      .then((response) => {
        dispatch({
          type: DELETE_ROLE_SUCCESS,
          payload: role_id
        });
        Swal.fire({
          icon: "success",
          title: "Role deleted successfully!",
          timer: 2000
        });
      })
      .catch((error) => {
        dispatch({
          type: DELETE_ROLE_ERROR,
          payload: []
        });
        errorHandler(dispatch, error.response, API_ERROR);
      })
  }
}

export function fetchOneRole(role_id) {
  return function (dispatch) {
    dispatch({
      type: FETCH_ONE_ROLE
    });

    apiV2.get(`/admin-roles/${role_id}`)
      .then((response) => {
        dispatch({
          type: FETCH_ONE_ROLE_SUCCESS,
          payload: response.data
        })
      })
      .catch((error) => {
        dispatch({
          type: FETCH_ONE_ROLE_ERROR,
          payload: []
        });
        errorHandler(dispatch, error.response, API_ERROR);
      })
  }
}
